import { preloadImage } from '@mail/3promo';
import { DOMAIN_HOST } from 'reactApp/appHelpers/configHelpers';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { VkMusicBundleSelectors } from 'reactApp/modules/vkMusic/vkMusic.selectors';
import { type VKIDInfo, VkMusicBundleVkidSource } from 'reactApp/modules/vkMusic/vkMusic.types';
import { store as reduxStore } from 'reactApp/store';

import type { VkMusicAnonymousConfirmModalProps } from './VkMusicAnonymousConfirmModal';
import type { VkMusicConfirmModalProps } from './VkMusicConfirmModal';

const IMAGE_PRELOAD_TIMEOUT = 3 * 1000;

export const renderVkMusicConfirmModal = (data: VkMusicConfirmModalProps) =>
    openPopupHelper({ popupName: popupNames.VK_MUSIC_CONFIRM_MODAL, data, onClose: data.onClose });

export const renderVkMusicAnonymousConfirmModal = (data: VkMusicAnonymousConfirmModalProps) =>
    openPopupHelper({ popupName: popupNames.VK_MUSIC_ANONYMOUS_CONFIRM_MODAL, data, onClose: data.onClose });

export const closeVkMusicConfirmModal = () => closePopupHelper(popupNames.VK_MUSIC_CONFIRM_MODAL);
export const closeVkMusicAnonymousConfirmModal = () => closePopupHelper(popupNames.VK_MUSIC_ANONYMOUS_CONFIRM_MODAL);

export const getAvatarSrc = (email: string, name: string, size = 45): string => {
    return `//filin.${DOMAIN_HOST}/pic?from=ph&email=${encodeURIComponent(email)}&width=${size}&height=${size}${
        name ? `&name=${encodeURIComponent(name)}` : ''
    }`;
};

export const preloadAvatars = async (vkidUser: VKIDInfo) => {
    const state = reduxStore.getState();
    const isSocialVKID = vkidUser.vkidSource === VkMusicBundleVkidSource.social;
    const email = UserSelectors.getEmail(state);
    const fullName = VkMusicBundleSelectors.getFullName(state);

    const mailAvatar = getAvatarSrc(email || '', fullName, 144);
    const vkidAvatar = vkidUser.avatar || getAvatarSrc(`${vkidUser.login}@vk`, vkidUser.firstName, 144);

    if (!isSocialVKID) {
        await preloadImage({ src: mailAvatar, timeout: IMAGE_PRELOAD_TIMEOUT });
    }
    await preloadImage({ src: vkidAvatar, timeout: IMAGE_PRELOAD_TIMEOUT });
};
